import { ChainId, Token } from '@pancakeswap/sdk'

export const CAKE: { [chainId: number]: Token } = {
  [ChainId.MAINNET]: new Token(
    ChainId.MAINNET,
    '0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82',
    18,
    'CAKE',
    'PancakeSwap Token',
  ),
  [ChainId.TESTNET]: new Token(
    ChainId.TESTNET,
    '0xa35062141Fa33BCA92Ce69FeD37D0E8908868AAe',
    18,
    'CAKE',
    'PancakeSwap Token',
  ),
}
export const BUSD: { [chainId: number]: Token } = {
  [ChainId.MAINNET]: new Token(
    ChainId.MAINNET,
    '0xe9e7cea3dedca5984780bafc599bd69add087d56',
    18,
    'BUSD',
    'Binance USD',
  ),
  [ChainId.TESTNET]: new Token(
    ChainId.TESTNET,
    '0xeD24FC36d5Ee211Ea25A80239Fb8C4Cfd80f12Ee',
    18,
    'CZUSD',
    'Binance USD',
  ),
}
export const WBNB = new Token(ChainId.MAINNET, '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c', 18, 'WBNB', 'Wrapped BNB')
export const DAI = new Token(ChainId.MAINNET, '0x1AF3F329e8BE154074D8769D1FFa4eE058B1DBc3', 18, 'DAI', 'Dai Stablecoin')
export const USDT = new Token(ChainId.MAINNET, '0x55d398326f99059fF775485246999027B3197955', 18, 'USDT', 'Tether USD')
export const BTCB = new Token(ChainId.MAINNET, '0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c', 18, 'BTCB', 'Binance BTC')
export const UST = new Token(
  ChainId.MAINNET,
  '0x23396cf899ca06c4472205fc903bdb4de249d6fc',
  18,
  'UST',
  'Wrapped UST Token',
)
export const ETH = new Token(
  ChainId.MAINNET,
  '0x2170Ed0880ac9A755fd29B2688956BD959F933F8',
  18,
  'ETH',
  'Binance-Peg Ethereum Token',
)
export const USDC = new Token(
  ChainId.MAINNET,
  '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d',
  18,
  'USDC',
  'Binance-Peg USD Coin',
)




const tokens = {
  bnb: {
    symbol: 'BNB',
    projectLink: 'https://www.binance.com/',
  },

	axd: {
	symbol: 'AXD',
	address: {
	56: '0xb26820dacbcc00ef870d56f4e81905239cc2acb6',
	97: '0xb26820dacbcc00ef870d56f4e81905239cc2acb6',
	},
	decimals: 18,
	projectLink: 'https://axiomadex.com/',
	},
  
  btc: {
    symbol: 'BTC',
    address: {
      56: '0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c',
    },
    decimals: 18,
    projectLink: 'https://bitcoin.org/',
  },
  eth: {
    symbol: 'ETH',
    address: {
      56: '0x2170Ed0880ac9A755fd29B2688956BD959F933F8',
    },
    decimals: 18,
    projectLink: 'https://ethereum.org/',
  },
    
	
	    cbu: {
		symbol: 'CBU',
		address: {
		56: '0x912ef48f4da0c68d6c7c6d0b35d4e62e71771f33',
		97: '',
		},
		decimals: 4,
		projectLink: 'https://bankuniversal.org/',
		},
		
		gtc: {
		symbol: 'GTC',
		address: {
		56: '0x6cd871fb811224aa23b6bf1646177cdfe5106416',
		97: '',
		},
		decimals: 4,
		projectLink: 'https://gtibcoin.com/',
		},
		
		qex: {
		symbol: 'QEX',
		address: {
		56: '0x124dc90b86fbfbe7119474b236e5b1c94189081b',
		97: '',
		},
		decimals: 18,
		projectLink: 'https://www.quantumex.ai/',
		},
		
        sol: {
		symbol: 'SOL',
		address: {
		56: '0x570A5D26f7765Ecb712C0924E4De545B89fD43dF',
		97: '',
		},
		decimals: 18,
		projectLink: 'https://solana.com/',
		},
		
		btcb: {
		symbol: 'BTCB',
		address: {
		56: '0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c',
		97: '0xE02dF9e3e622DeBdD69fb838bB799E3F168902c5',
		},
		decimals: 18,
		projectLink: 'https://bitcoin.org/',
		},
		ada: {
		symbol: 'ADA',
		address: {
		56: '0x3EE2200Efb3400fAbB9AacF31297cBdD1d435D47',
		97: '0xE02dF9e3e622DeBdD69fb838bB799E3F168902c5',
		},
		decimals: 18,
		projectLink: 'https://www.cardano.org/',
		},
		link: {
		symbol: 'LINK',
		address: {
		56: '0xF8A0BF9cF54Bb92F17374d9e9A321E6a111a51bD',
		97: '0xE02dF9e3e622DeBdD69fb838bB799E3F168902c5',
		},
		decimals: 18,
		projectLink: 'https://chain.link/',
		},
		
		dot: {
		symbol: 'DOT',
		address: {
		56: '0x7083609fCE4d1d8Dc0C979AAb8c869Ea2C873402',
		97: '',
		},
		decimals: 18,
		projectLink: 'https://polkadot.network/',
		},
		
		doge: {
		symbol: 'DOGE',
		address: {
		56: '0xbA2aE424d960c26247Dd6c32edC70B295c744C43',
		97: '',
		},
		decimals: 8,
		projectLink: 'https://dogecoin.com/',
		},
		
		usdc: {
		symbol: 'USDC',
		address: {
		56: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d',
		97: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d',
		},
		decimals: 18,
		projectLink: 'https://www.centre.io/usdc',
		},
		
		fil: {
		symbol: 'FIL',
		address: {
		56: '0x0d8ce2a99bb6e3b7db580ed848240e4a0f9ae153',
		97: '0x0d8ce2a99bb6e3b7db580ed848240e4a0f9ae153',
		},
		decimals: 18,
		projectLink: 'https://filecoin.io/',
		},
		
		axt: {
		symbol: 'AXT',
		address: {
		56: '0xbb6b75ad7ab30a172e7b5ce46ef2fcf299d14219',
		97: '',
		},
		decimals: 18,
		projectLink: 'https://axiomadex.com/',
		},
// ***************************************** default token   ********************************** 
 
		cake: {
		symbol: 'CAKE',
		address: {
		56: '0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82',
		97: '0xa35062141Fa33BCA92Ce69FeD37D0E8908868AAe',
		},
		decimals: 18,
		projectLink: 'https://pancakeswap.finance/',
		},
 
		wbnb: {
		symbol: 'wBNB',
		address: {
		56: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
		97: '0xae13d989dac2f0debff460ac112a837c89baa7cd',
		},
		decimals: 18,
		projectLink: 'https://pancakeswap.finance/',
		},

		busd: {
		symbol: 'BUSD',
		address: {
		56: '0xe9e7cea3dedca5984780bafc599bd69add087d56',
		97: '',
		},
		decimals: 18,
		projectLink: 'https://axiomadex.com/',
		},
		
	

		syrup: {
		symbol: 'SYRUP',
		address: {
		56: '0xa067377b6682fc5e48cfcd3440be9284e950dcd6',
		97: '0xa067377b6682fc5e48cfcd3440be9284e950dcd6',
		},
		decimals: 18,
		projectLink: 'https://pancakeswap.finance/',
		},

		usdt: {
		symbol: 'USDT',
		address: {
		56: '0x55d398326f99059fF775485246999027B3197955',
		97: '0xE02dF9e3e622DeBdD69fb838bB799E3F168902c5',
		},
		decimals: 18,
		projectLink: 'https://tether.to/',
		},

		kalm: {
		symbol: 'KALM',
		address: {
		56: '0x4BA0057f784858a48fe351445C672FF2a3d43515',
		97: '',
		},
		decimals: 18,
		projectLink: 'https://kalmar.io/',
		},

		hotcross: {
		symbol: 'HOTCROSS',
		address: {
		56: '0x4FA7163E153419E0E1064e418dd7A99314Ed27b6',
		97: '',
		},
		decimals: 18,
		projectLink: 'https://www.hotcross.com/',
		},

		hzn: {
		symbol: 'HZN',
		address: {
		56: '0xC0eFf7749b125444953ef89682201Fb8c6A917CD',
		97: '',
		},
		decimals: 18,
		projectLink: 'https://horizonprotocol.com/',
		},

		belt: {
		symbol: 'BELT',
		address: {
		56: '0xE0e514c71282b6f4e823703a39374Cf58dc3eA4f',
		97: '',
		},
		decimals: 18,
		projectLink: 'https://beta.belt.fi/',
		},

		watch: {
		symbol: 'WATCH',
		address: {
		56: '0x7A9f28EB62C791422Aa23CeAE1dA9C847cBeC9b0',
		97: '',
		},
		decimals: 18,
		projectLink: 'https://yieldwatch.net/',
		},

		bry: {
		symbol: 'BRY',
		address: {
		56: '0xf859Bf77cBe8699013d6Dbc7C2b926Aaf307F830',
		97: '',
		},
		decimals: 18,
		projectLink: 'https://berrydata.co/',
		},

		wsote: {
		symbol: 'wSOTE',
		address: {
		56: '0x541E619858737031A1244A5d0Cd47E5ef480342c',
		97: '',
		},
		decimals: 18,
		projectLink: 'https://soteria.finance/#/',
		},

		helmet: {
		symbol: 'Helmet',
		address: {
		56: '0x948d2a81086A075b3130BAc19e4c6DEe1D2E3fE8',
		97: '',
		},
		decimals: 18,
		projectLink: 'https://www.helmet.insure/',
		},

		ten: {
		symbol: 'TEN',
		address: {
		56: '0xdFF8cb622790b7F92686c722b02CaB55592f152C',
		97: '',
		},
		decimals: 18,
		projectLink: 'https://www.tenet.farm/',
		},

		ditto: {
		symbol: 'DITTO',
		address: {
		56: '0x233d91A0713155003fc4DcE0AFa871b508B3B715',
		97: '',
		},
		decimals: 9,
		projectLink: 'https://ditto.money/',
		},

		blink: {
		symbol: 'BLINK',
		address: {
		56: '0x63870A18B6e42b01Ef1Ad8A2302ef50B7132054F',
		97: '',
		},
		decimals: 6,
		projectLink: 'https://blink.wink.org',
		},

		qsd: {
		symbol: 'QSD',
		address: {
		56: '0x07AaA29E63FFEB2EBf59B33eE61437E1a91A3bb2',
		97: '',
		},
		decimals: 18,
		projectLink: 'https://chemix.io/home',
		},

		bondly: {
		symbol: 'BONDLY',
		address: {
		56: '0x96058f8C3e16576D9BD68766f3836d9A33158f89',
		97: '',
		},
		decimals: 18,
		projectLink: 'https://www.bondly.finance/',
		},

		safemoon: {
		symbol: 'SAFEMOON',
		address: {
		56: '0x8076C74C5e3F5852037F31Ff0093Eeb8c8ADd8D3',
		97: '',
		},
		decimals: 9,
		projectLink: 'https://safemoon.net/',
		},
  
}


export default tokens


